import * as React from 'react';

class PaymentForm extends React.Component<any> {
  public render() {
    return (
      <div>
        <h2>Deine Zahlungsart</h2>
        <p>Rechnung</p>
      </div>
    );
  }
}
export default PaymentForm;


// WEBPACK FOOTER //
// ./src/components/checkout/PaymentForm.tsx